import { join } from 'lodash';

export function createPrefixer(...prefixes: $TSFixMe[]) {
    return (str: $TSFixMe) => join([...prefixes, str], '/');
}
